import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';

interface IDeleteGlobalRateLimitProfileModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-delete-global-ratelimit-profile',
  templateUrl: './delete-global-ratelimit-profile.component.html',
  styleUrls: ['./delete-global-ratelimit-profile.component.scss'],
})
export class DeleteGlobalRateLimitProfileModalComponent
  implements OnInit, OnDestroy
{
  constructor(
    public modal: SuiModal<
      IDeleteGlobalRateLimitProfileModalContext,
      void,
      void
    >,
    @Inject(DOCUMENT) private document
  ) {}

  ngOnInit() {
    this.document.body.classList.remove('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}

export class DeleteGlobalRateLimitProfileModal extends ComponentModalConfig<
  IDeleteGlobalRateLimitProfileModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(DeleteGlobalRateLimitProfileModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
